import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import RadioButton from "../components/RadioButton";
import Textarea from "../components/Textarea";
import "./SingleChoiceOther.scss";

const SingleChoiceOther = ({
  question,
  fieldName,
  value,
  error,
  otherTextValue,
  otherTextError,
  setFieldValue,
  setFieldTouched,
}) => {
  const { t } = useTranslation(["survey"]);
  const handleRadioChange = e => {
    setFieldValue(fieldName, e.target.value);
    setFieldTouched(fieldName, true);

    // Clear other text if switching away from "other"
    if (e.target.value !== "other") {
      setFieldValue(`${fieldName}_other_text`, "");
    }
  };

  const handleOtherTextChange = e => {
    setFieldValue(`${fieldName}_other_text`, e.target.value);
  };

  const handleOtherTextBlur = () => {
    setFieldTouched(`${fieldName}_other_text`, true);
  };

  return (
    <div className="single-choice-other">
      <div className="single-choice-other__header">
        {question.question && (
          <h2 className="single-choice-other__title">
            {question.question}
            {question.required && (
              <span className="single-choice-other__required">*</span>
            )}
          </h2>
        )}
        <p className="single-choice-other__subtitle">{question.helper_text}</p>
      </div>

      <div className="single-choice-other__options">
        {question.options &&
          question.options.map((option, index) => (
            <RadioButton
              key={`${fieldName}-${index}`}
              id={`${fieldName}-${index}`}
              name={fieldName}
              value={option}
              label={option}
              checked={value === option}
              onChange={handleRadioChange}
            />
          ))}

        {/* Other option */}
        <div className="single-choice-other__other-container">
          <RadioButton
            id={`${fieldName}-other`}
            name={fieldName}
            value="other"
            label={t("survey:wizard.other")}
            checked={value === "other"}
            onChange={handleRadioChange}
          />

          {value === "other" && (
            <div className="single-choice-other__other-text">
              <Textarea
                name={`${fieldName}_other_text`}
                value={otherTextValue || ""}
                onChange={handleOtherTextChange}
                onBlur={handleOtherTextBlur}
                placeholder={t("survey:wizard.placeholderOpenQuestion")}
                rows={3}
                className={
                  otherTextError ? "single-choice-other__textarea--error" : ""
                }
              />
              {otherTextError && (
                <div className="single-choice-other__error">
                  {otherTextError}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {error && <div className="single-choice-other__error">{error}</div>}
    </div>
  );
};

SingleChoiceOther.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  otherTextValue: PropTypes.string,
  otherTextError: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

SingleChoiceOther.defaultProps = {
  value: "",
  error: null,
  otherTextValue: "",
  otherTextError: null,
};

export default SingleChoiceOther;
